/**
 * Formats a date for activity-log UI; invalid or empty values show an em dash.
 * @param {string | number | Date | null | undefined} value
 * @returns {string}
 */
export function formatActivityLogDateCell(value) {
  if (value == null || value === "") {
    return "—";
  }
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? "—" : d.toLocaleString();
}
